// API Configuration: force static IP in production; allow env/proxy in dev
const isDev = typeof window !== 'undefined' && window.location && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '::1');

// Use the same base URL in development and production unless explicitly overridden by env
const envBase = (
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_BASE_URL)
) || 'https://api.khwanzay.school/api/v1';

const envSocket = (
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_SOCKET_URL)
) || 'https://api.khwanzay.school';

const API_CONFIG = {
  baseURL: envBase,
  socketURL: envSocket,
  description: 'Env-based API config (Vite) with static IP fallback'
};

// Export current configuration (always production for cPanel)
export const currentConfig = API_CONFIG;

// Debug log to confirm configuration
// console.log('API Configuration loaded:', currentConfig);

// Export individual values for convenience
export const API_BASE_URL = currentConfig.baseURL;
export const SOCKET_URL = currentConfig.socketURL;

// Export full config for debugging
export const API_CONFIG_FULL = {
  current: currentConfig,
  all: API_CONFIG,
  environment: 'production'
};

// Helper function to get full URL
export const getFullURL = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

// Helper function to get socket URL
export const getSocketURL = () => {
  return SOCKET_URL;
};

export default API_CONFIG; 